import { render, staticRenderFns } from "./AuditPendenciesTypeCard.vue?vue&type=template&id=7345e743&scoped=true"
import script from "./AuditPendenciesTypeCard.vue?vue&type=script&lang=js"
export * from "./AuditPendenciesTypeCard.vue?vue&type=script&lang=js"
import style0 from "./AuditPendenciesTypeCard.vue?vue&type=style&index=0&id=7345e743&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7345e743",
  null
  
)

export default component.exports